import React, { useState } from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Banner from "../../images/homepage/slider_banner.jpeg";



const images = [
  "Slide_Team_2023.jpg",
  "Slide_Double_2023.jpg",
  "Slide_Double_2023-4.jpg",
  "Slide_Triple_2023.jpg",
  "Slide_Double_2023-2.jpg",
  "Slide_Double_2023-3.jpg",
  "Slide_VM_2022.jpg",
  "Slide_UG3.jpg",
  "Slide_UG2.jpg",
  "Slide_UG1.jpg",
  "STF-2022-039.jpg",
  "STF-2022-040.jpg",
  "STF-2022-047.jpg",
  "STF-2022-049.jpg",
  "slide_Marathon_2022.jpg",
  "laufen_marathon_2022.jpg",
  "laufen_marathon_2022-2.jpg",
  "slide_Wh_2021.jpg",
  "Titel_10_Jahre.jpg",
  "slide_nOrdi_13.jpg",
  "slide_nOrdi_14.jpg",
  "slide_nOrdi_15.jpg",
  "slide_nOrdi_16.jpg",
  "slide_nOrdi_17.jpg",
  "slide_nOrdi_18.jpg",
  "slide_nOrdi_19.jpg",
  "slide_nOrdi_20.jpg",
  "slide_nOrdi_21.jpg",
  "slide_nOrdi_22.jpg",
  "slide_nOrdi_23.jpg",
  "slide_sebald.jpg",
  "slide_team_7.jpg",
  "slide_nOrdi_1.jpg",
  "slide_team_8.jpg",
  "slide_nOrdi_2.jpg",
  "slide_team_9.jpg",
  "slide_nOrdi_3.jpg",
  "slide_team_10.jpg",
  "slide_wh_2014.jpg",
  "slide_team.jpg",
  "slide_ekg.jpg",
  "slide_nOrdi_6.jpg",
  "slide_schall_1.jpg",
  "slide_nOrdi_7.jpg",
  "slide_team_5.jpg",
  "slide_nOrdi_8.jpg",
  "slide_labor.jpg",
  "slide_schall_2.jpg",
  "slide_nOrdi_9.jpg",
  "slide_team_3.jpg",
  "slide_nOrdi_5.jpg",
  "slide_nOrdi_11.jpg",
  "slide_wh_2017.jpg",
  "slide_nOrdi_10.jpg",
  "slide_ergo.jpg",
  "slide_team_4.jpg",
  "slide_wh_2018.jpg",
  "slide_nOrdi_12.jpg",
  "slide_team_6.jpg"
];


const Carousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const fixedHeight = 600; // px
    const maxWidth = 800;    // px max width
  
    const prevSlide = () => {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
    };
  
    const nextSlide = () => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    };
  
    return (
      <div
        style={{
          width: "100%",
          maxWidth: maxWidth,
          height: fixedHeight,
          margin: "0 auto",
          textAlign: "center",
          position: "relative",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <img
          src={`/images/carousel/${images[currentIndex]}`}
          alt={`Slide ${currentIndex + 1}`}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
            margin: "0 auto",
          }}
        />
        <button
          onClick={prevSlide}
          style={{
            position: "absolute",
            top: "50%",
            left: "10px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            cursor: "pointer",
            userSelect: "none",
          }}
          aria-label="Previous Slide"
        >
          ‹
        </button>
        <button
          onClick={nextSlide}
          style={{
            position: "absolute",
            top: "50%",
            right: "10px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            cursor: "pointer",
            userSelect: "none",
          }}
          aria-label="Next Slide"
        >
          ›
        </button>
        <p
          style={{
            position: "absolute",
            bottom: "10px",
            width: "100%",
            color: "black",
            margin: 0,
            fontWeight: "bold",
            userSelect: "none",
          }}
        >
          {currentIndex + 1} / {images.length}
        </p>
      </div>
    );
};  

const Slides = () => {
  return (
    <main>
      <Header image={Banner} />
      <section className="content-section">
        <Navbar />
        <div className="page-container">
          <h1>Galerie</h1>
          <Carousel />
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default Slides;
